import { Box, Typography } from 'src/components'
import styled from 'styled-components'

export const BackButton = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 118px;
    height: 40px;
    cursor: pointer;
    margin-bottom: 15px;
    padding: 0 12px;
`

export const IconContainer = styled(Box)`
    display: flex;
`
export const TypographyContent = styled(Typography)`
    display: flex;
    font-family: inherit;
`
